module.exports = __webpack_public_path__ + "img/mms-referral.22db5c74.png";